export const SET_CATALOG_ITEMS = 'SET_CATALOG_ITEMS';
export const SET_IS_LOADING_CATALOG = 'SET_IS_LOADING_CATALOG';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_IS_LOADING_FILTERS = 'SET_IS_LOADING_FILTERS';
export const SET_SELECTED_VALUES = 'SET_SELECTED_VALUES';
export const SET_COLUMNS_ORDER = 'SET_COLUMNS_ORDER';
export const SET_IS_LOADING_UPDATE_REFERENCES = 'SET_IS_LOADING_UPDATE_REFERENCES';